<template>
  <div class="product-image-controls">
    <div
      v-if="product && isARButtonEnabled && mounted"
      class="product-viewer-button-desktop"
      :key="`product-viewer-button-desktop-${product.hashKey}`"
    >
      <ProductViewerButton :product="product" />
    </div>
    <button @click="$emit('zoom')" class="product-buy-image-expand button white filled zoom-btn" title="Open Fullscreen">
      <ZoomIcon />
    </button>
  </div>
</template>
<script>
import { computed } from 'vue';
import ProductViewerButton from '@/components/product/ProductViewerButton.vue';
import ZoomIcon from '@/assets/product/zoom-in.svg';
import useExperiment from '@/compositions/useExperiment.js';
import useLifecycleHook from '@/compositions/useLifecycleHook.js';

export default {
  name: 'ProductImageControls',
  components: {
    ProductViewerButton,
    ZoomIcon,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  emits: ['zoom'],
  setup() {
    const { mounted } = useLifecycleHook();
    const { isFeatureVariant } = useExperiment();
    const isARButtonEnabled = computed(() => isFeatureVariant('ar-button', 'on'));

    return {
      mounted,
      isARButtonEnabled,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.product-image-controls {
  position: absolute;
  top: var(--space-4);
  right: var(--space-4);
  display: flex;
  align-items: center;
}

.product-viewer-button-desktop {
  display: none;

  @media (min-width: $mobile-breakpoint) {
    display: block;
  }
}

.product-buy-image-expand {
  margin-left: var(--space-2);
}

.product-buy-image-expand-icon {
  width: 16px;
}

.zoom-btn {
  display: block;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid;
  background-color: white;
  border-color: var(--grey-light);
  right: 20px;
  padding: 11px !important;
}
</style>
